const updates = [
  {
    date: '2026.07.28',
    tag: '新番',
    tagColor: 'bg-accent-500',
    text: '《我独自升级》第二季已更新至第18话，韩漫之家同步提供离线下载。',
  },
  {
    date: '2026.07.25',
    tag: '推荐',
    tagColor: 'bg-primary-500',
    text: '本周韩漫推荐：《全知读者视角》与《反派小姐的男主人公》，下载量激增。',
  },
  {
    date: '2026.07.22',
    tag: '更新',
    tagColor: 'bg-secondary-500',
    text: '韩漫APK v3.8.2版本发布，优化离线下载速度，修复部分机型闪退问题。',
  },
  {
    date: '2026.07.18',
    tag: '汉化',
    tagColor: 'bg-accent-600',
    text: '《剑尊归来》最新话汉化完成，韩漫之家专题页已更新阅读入口。',
  },
  {
    date: '2026.07.15',
    tag: '活动',
    tagColor: 'bg-primary-600',
    text: '暑期韩漫阅读季开启，多款韩漫APP推出免费离线阅读限时活动。',
  },
  {
    date: '2026.07.10',
    tag: '攻略',
    tagColor: 'bg-secondary-600',
    text: '发布韩漫下载安装图文教程V2.0，新增iOS设备韩漫离线设置详细步骤。',
  },
  {
    date: '2026.07.05',
    tag: '资源',
    tagColor: 'bg-accent-500',
    text: '新增50+完结韩漫离线资源包，涵盖恋爱、奇幻、悬疑等热门分类。',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            韩漫之家最新更新与韩漫圈热点速递
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[27px] top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-5">
            {updates.map((item) => (
              <div key={item.text} className="relative flex items-start gap-4 md:gap-6 pl-12 md:pl-16">
                <div className={`absolute left-[12px] md:left-[19px] w-4 h-4 rounded-full ${item.tagColor} border-2 border-background-100 z-10`}></div>

                <div className="min-w-0 flex-1 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className={`px-2 py-0.5 rounded-md text-xs font-medium ${item.tagColor} text-background-50`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.date}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}